// // import React from 'react'
// // import { Line } from 'react-chartjs-2'
// // export const options = {
// //   responsive: true,
// //   plugins: {
// //     legend: {
// //       position: 'top',
// //     },
// //     title: {
// //       display: true,
// //       text: 'Sales Report',
// //     },
// //   },
// // };
// // const LineGraph = ({graphData}) => {
// // const data = {
// //         labels:graphData.labels,
// //         datasets: [
// //           {
// //             label: 'Dataset',
// //             data: graphData.data,
// //             borderColor: 'rgb(255, 99, 132)',
// //             backgroundColor: 'rgba(255, 99, 132, 0.5)',
// //           }
// //         ],
// //       };
// //   return (
// // <Line options={options} data={data} />
// //   )
// // }

// // export default LineGraph

// import React from 'react'
// import { Line } from 'react-chartjs-2'
//  const options = {
//     responsive: true,
//     plugins: {
//       legend: {
//         position: 'top',
//       },
//       title: {
//         display: true,
//         text: 'Bill Report',
//       },
//     },
//   };
// const LineGraph = ({graphData}) => {
// const data = {
//         labels:graphData.labels,
//         datasets: [
//           {
//             label: 'Dataset',
//             data: graphData.data,
//             borderColor: 'rgb(255, 99, 132)',
//             backgroundColor: 'rgba(255, 99, 132, 0.5)',
//           }
//         ],
//       };
//   return (
// <Line style={{width:"40rem",height:"20rem"}} options={options} data={data} />
//   )
// }

// export default LineGraph


import React from 'react';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
);

// const options = {
//     responsive: true,
//     plugins: {
//       legend: {
//         position: 'top',
//       },
//       title: {
//         display: true,
//         text: 'Bill Report',
//         font: {
//           size: 15,
//           weight: 'bold',
//           color: 'black',
//         },
//       },
//     },
//   };
const LineGraph = ({ graphData }) => {
  const dataValues = graphData.data || [];
  const minValue = dataValues.length > 0 ? Math.min(...dataValues) : 0;
  const maxValue = dataValues.length > 0 ? Math.max(...dataValues) : 100; // Default max if no data

  let yAxisMin;
  let yAxisMax;

  if (minValue === maxValue) {
    // Handle case where all data points are the same
    yAxisMin = minValue > 0 ? minValue * 0.9 : 0;
    yAxisMax = maxValue * 1.1 + 1; // Add a small amount to prevent a flat line at 0
  } else {
    const padding = (maxValue - minValue) * 0.1; // 10% padding
    yAxisMin = Math.max(0, minValue - padding); // Ensure min is not less than 0
    yAxisMax = maxValue + padding;
  }


  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        titleFont: {
          size: 14,
        },
        bodyFont: {
          size: 12,
        },
        callbacks: {
          label: function (context) {
            return `Sales: ₹${context.raw.toLocaleString('en-IN')}`;
          },
        },
      },
    },
    scales: {
      y: {
        beginAtZero: false, // Allow y-axis to not start at zero
        min: yAxisMin,
        max: yAxisMax,
      },
    },
    interaction: {
      intersect: false,
      mode: 'index',
    },
  };

  const data = {
    labels: graphData.labels,
    datasets: [
      {
        label: 'Sales',
        data: graphData.data,
        borderColor: '#5E72E4',
        backgroundColor: (context) => {
          const ctx = context.chart.ctx;
          if (!ctx) {
            return 'rgba(94, 114, 228, 0.1)';
          }
          const gradient = ctx.createLinearGradient(0, 0, 0, 250);
          gradient.addColorStop(0, 'rgba(94, 114, 228, 0.4)');
          gradient.addColorStop(1, 'rgba(94, 114, 228, 0)');
          return gradient;
        },
        fill: true,
        tension: 0.4,
        pointBackgroundColor: '#5E72E4',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: '#5E72E4',
        pointRadius: 4,
        pointHoverRadius: 6,
      },
    ],
  };
  return <Line style={{ width: '100%', height: '250px' }} options={options} data={data} />;
};

export default LineGraph;



